import React from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PlayerAvatar from '../../../components/ui/PlayerAvatar';
import tokens from '../../../theme/tokens';

const PlayerCard = ({ player, onEdit, onDelete }) => {
  const playerName = player.nome.split(' ').slice(0, 2).join(' ');

  return (
    <Card sx={{ p: 2, height: '100%' }}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <PlayerAvatar src={player.foto} name={player.nome} size={52} />
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography fontWeight={700} noWrap title={player.nome}>{playerName}</Typography>
          <Typography variant="body2" color="text.secondary">Camisa {player.tamanhoCamisa || '-'}</Typography>
        </Box>
        <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '2rem', color: tokens.color.brand }}>
          {player.numeroCamisa}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mt: 1.5 }}>
        <Chip size="small" label={player.pago === 'SIM' ? 'Pago' : 'Não pago'} color={player.pago === 'SIM' ? 'success' : 'error'} variant="outlined" />
        {player.festa === 'SIM' && <Chip size="small" label="Festa" color="warning" variant="outlined" />}
        {player.pais && <Chip size="small" label={player.pais} variant="outlined" />}
      </Stack>
      {player.nomeConvidado && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>Convidado: {player.nomeConvidado}</Typography>
      )}
      <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
        <Tooltip title="Editar"><IconButton size="small" onClick={() => onEdit(player)}><EditIcon fontSize="small" /></IconButton></Tooltip>
        <Tooltip title="Excluir"><IconButton size="small" color="error" onClick={() => onDelete(player)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>
      </Stack>
    </Card>
  );
};

export default PlayerCard;
